import { createHookContext } from '@clover-util/react-context';
import { useState } from 'react';

export const { usePaymentsToggle, PaymentsToggleProvider } = createHookContext('PaymentsToggle', () => {
  const [isPayMonthly, setIsPayMonthly] = useState<boolean>(true);

  return {
    isPayMonthly,
    setIsPayMonthly,
  };
});
